import { Typography } from '@atlas-metrics/design-system';

import { Paragraph } from './widgets/projects';
import InfoBox from './widgets/projects/InfoBox';
import ProjectGallery from './widgets/projects/ProjectGallery';

import { Project, ProjectAsset, Projects } from '@/types';

export interface IProjectContentProps {
  projects: Projects;
}

const ProjectsContent: React.FC<IProjectContentProps> = ({ projects }) => {
  const getGalleryItem = (entries: Project[], assets: ProjectAsset[]) => {
    return entries
      ?.sort(
        (entry1: Project, entry2: Project) =>
          entry1.sortIndex - entry2.sortIndex
      )
      .map((entry) => {
        const img = assets.find(
          (assetItem) => assetItem.sys.id === entry.image.sys.id
        );

        const smallImg = assets.find(
          (assetItem) => assetItem.sys.id === entry.smallImage?.sys.id
        );
        return {
          title: entry.title,
          description: entry.description,
          imageSrc: img?.fields.file.url ?? '',
          smallImageSrc: smallImg?.fields.file.url ?? null,
          viewMoreLink: entry.linkUrl,
        };
      });
  };

  const { project, entries, assets } = projects;

  return (
    <ul className='mb-20 webL:mb-6'>
      <li>
        <div className='mb-[50px] ml-4 flex w-full scroll-mt-24'>
          <Typography variant='h4'>{project.title}</Typography>
        </div>
        {project.introductionText && (
          <Paragraph
            className='my-4 ml-4'
            richText={project.introductionText}
          />
        )}
        {project.showBoxes && (
          <>
            <InfoBox
              className='mt-8'
              title={project.boxesTitle}
              leftProjectSummary={{
                title: project.firstBoxCaption,
                value: project.firstBoxHighlight,
              }}
              rightProjectSummary={{
                title: project.secondBoxCaption,
                value: project.secondBoxHighlight,
              }}
            />
            <Paragraph
              className='ml-4 mt-4'
              richText={project.textBelowBoxes}
            />
          </>
        )}
        {entries?.length > 0 && (
          <ProjectGallery
            title={project.galleryTitle}
            className='mt-8'
            galleryItems={getGalleryItem(entries, assets)}
          />
        )}
        {project.bottomText && (
          <Paragraph className='my-4 ml-4' richText={project.bottomText} />
        )}
      </li>
    </ul>
  );
};

export default ProjectsContent;
